<template>
  <div class="comp-login-dialog" v-show="loginDialogVisible">
    <login-form is-dialog show-close @close-click="hideLoginDialog" @should-close="hideLoginDialog"></login-form>
  </div>
</template>

<script>
  /**
   * @author yueheqin
   * @date 2018/12/18
   * @project kaoshizhongxin-pc
   * @desc 登录弹框组件
   */
  import { mapState, mapMutations, mapGetters } from 'vuex'
  import { loginApi } from '../api/login'
  import { SAVE_ACCOUNT_ACTIVE_KEY, USER_ACCOUNT_KEY } from '../config'
  import { getLocalItem, removeLocalItem, setLocalItem } from '../utils/storage'
  import { loginCBMixin } from '../mixins/login-callback'
  import LoginForm from './login-form.vue'

  export default {
    name: 'comp-login-dialog',
    components: {
      LoginForm
    },
    mixins: [loginCBMixin],
    data () {
      return {
        loginLoading: false,
        saveAccount: false,
        loginForm: {
          userName: '',
          password: ''
        }
      }
    },
    computed: {
      ...mapState('common', ['loginDialogVisible', 'loginSuccessHandle']),
      ...mapGetters('common', ['currentSubject', 'subjectList']),
      isComplete () {
        let form = this.loginForm
        return form.userName && form.password
      }
    },
    created () {
      this.loginForm.userName = getLocalItem(USER_ACCOUNT_KEY) || ''
      this.saveAccount = getLocalItem(SAVE_ACCOUNT_ACTIVE_KEY) || false
    },
    methods: {
      ...mapMutations('common', ['hideLoginDialog']),
      bindSaveAccountChange (val) {
        setLocalItem(SAVE_ACCOUNT_ACTIVE_KEY, val)
        if (val) {
          setLocalItem(USER_ACCOUNT_KEY, this.loginForm.userName)
        } else {
          removeLocalItem(USER_ACCOUNT_KEY)
        }
      },
      submitLogin () {
        let vm = this
        let form = vm.loginForm
        if (!form.userName) {
          vm.$message.warning('用户名不能为空！')
          return false
        }
        if (!form.password) {
          vm.$message.warning('密码不能为空！')
          return false
        }
        vm.loginLoading = true
        loginApi(form).then(data => {
          if (this.saveAccount) {
            setLocalItem(USER_ACCOUNT_KEY, vm.loginForm.userName)
          }
          vm.hideLoginDialog()
          this.loginCB(data)
          vm.loginLoading = false
          let handle = vm.loginSuccessHandle
          if (handle && handle.success) {
            handle.success.apply(handle.context, handle.successArgs)
          }
          let arr = ['FindPassword', 'Login', 'Register']
          if (arr.includes(this.$route.name)) {
            this.$router.replace({name: 'Index'})
          }
        }).catch(err => {
          vm.loginLoading = false
        })
      },
      bindGoFind () {
        this.hideLoginDialog()
        this.$router.push({name: 'FindPassword'})
      },
      bindGoReg () {
        this.hideLoginDialog()
        this.$router.push({name: 'Register'})
      }
    }
  }
</script>

<style lang="less">
  .comp-login-dialog {
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: rgba(0,0,0,.6);
    position: fixed;
    right:0;
    left:0;
    top:0;
    bottom:0;
    z-index: 2000;
  }
</style>
